<script>
  // Einstieg auf Home, solange weder Projekte noch Digital-Twin-Daten existieren.
  import { createEventDispatcher } from "svelte";
  import ButtonDefault from "../../../../lib/components/Button.svelte";

  export let canCreateProject = false;

  const dispatch = createEventDispatcher();
</script>

<section class="empty_home">
  <h2 class="empty_home_title">Welcome to paxray</h2>
  <p class="empty_home_text">
    Create your first initiative to get started.<br />
    New here?
    <button
      class="empty_home_tour"
      type="button"
      on:click={() => dispatch("startTour")}
    >
      Take a quick tour
    </button>
  </p>
  <div class="empty_home_actions">
    <ButtonDefault
      on:click={() => dispatch("setupFramework")}
      variant="secondary"
      size="sm"
      text="Set up framework (recommended)"
    />
    {#if canCreateProject}
      <ButtonDefault
        on:click={() => dispatch("createProject")}
        variant="secondary"
        size="sm"
        text="New Project"
      />
    {/if}
  </div>
</section>

<style>
  .empty_home {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    flex: 1;
    padding: 2rem 1rem;
    text-align: center;
    color: var(--pax-black, #1c1c20);
  }

  .empty_home_title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
  }

  .empty_home_text {
    max-width: 32rem;
    margin: 0;
    font-size: 1rem;
    line-height: 1.5;
    color: var(--pax-text-muted-color-new, #74747f);
  }

  .empty_home_actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--control-gap);
  }

  .empty_home_tour {
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    color: var(--pax-black, #1c1c20);
    text-decoration: underline;
    cursor: pointer;
  }
</style>
